(() => {
  const initializeHistory = (root) => {
    if (!root || root.dataset.lyoNosotrosHistoryReady === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-lyo-nosotros-history-slide]'));
    const controls = root.querySelector('[data-lyo-nosotros-history-controls]');
    const previous = root.querySelector('[data-lyo-nosotros-history-previous]');
    const next = root.querySelector('[data-lyo-nosotros-history-next]');
    const dots = root.querySelector('[data-lyo-nosotros-history-dots]');

    if (!controls || !previous || !next || !dots) return;

    root.dataset.lyoNosotrosHistoryReady = 'true';

    if (slides.length < 2) return;

    dots.replaceChildren();
    let activeIndex = 0;

    const dotButtons = slides.map((_, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'lyo-nosotros-history__dot';
      button.setAttribute('aria-label', `Mostrar hito ${index + 1}`);
      button.addEventListener('click', () => showSlide(index));
      dots.append(button);
      return button;
    });

    const showSlide = (index, keepDotVisible = false) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.hidden = !isActive;
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      dotButtons.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === activeIndex)));

      if (keepDotVisible) {
        const activeDot = dotButtons[activeIndex];
        const dotLeft = activeDot.offsetLeft;
        const dotRight = dotLeft + activeDot.offsetWidth;

        if (dotLeft < dots.scrollLeft) {
          dots.scrollLeft = dotLeft;
        } else if (dotRight > dots.scrollLeft + dots.clientWidth) {
          dots.scrollLeft = dotRight - dots.clientWidth;
        }
      }
    };

    previous.addEventListener('click', () => showSlide(activeIndex - 1, true));
    next.addEventListener('click', () => showSlide(activeIndex + 1, true));
    showSlide(0);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-lyo-nosotros-history]').forEach(initializeHistory);
  };

  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
